import merge from 'lodash/merge';
import map from 'lodash/map';
import get from 'lodash/get';
import { normalize } from 'normalizr';
import cloneDeep from 'lodash/cloneDeep';
import { DND_CONTENT_MODULE } from '../components/DragAndDrop/dndTypes';
import {
  ADD_CONTENT,
  ADD_COMPONENT,
  ADD_COMPONENT_TO_COLUMN,
} from '../actions/contentAdd';
import {
  MOVE_CONTENT,
  MOVE_COMPONENT,
} from '../actions/contentMove';
import {
  DELETE_CONTENT,
  DELETE_COMPONENT,
} from '../actions/contentDelete';
import {
  DELETE_MEDIA,
} from '../actions/mediaDelete';
import {
  SET_MEDIA_OPTION,
} from '../actions/mediaConfig';
import {
  SHOW_CONTENT_COMPONENT_BY_TYPE,
  HIDE_CONTENT_COMPONENT_BY_TYPE,
} from '../actions/contentComponentToggle';
import {
  SET_CONTENT_OPTION,
  MERGE_CONTENT_OPTION,
  CLEAR_CONTENT_OPTION,
  SET_COMPONENT_OPTION,
  CLEAR_COMPONENT_OPTION, APPEND_COLUMN_COMPONENTS,
} from '../actions/contentConfig';
import {
  PAGE_REORDER, PAGES_SUCCESS,
} from '../actions/pages';
import {
  SET_CONTENT_COLUMN_COUNT,
} from '../actions/contentColumns';
import { LANGUAGES_FETCH_SUCCESS } from '../actions/languages';
import { CLONE_CONTENT } from '../actions/contentClone';
import {
  MEDIA_FOLDERS_REQUEST,
  MEDIA_FOLDERS_SUCCESS,
  MEDIA_SUCCESS,
  MEDIA_UPLOAD_SUCCESS,
  deleteMediaFolder,
  updateMediaFolder,
  createMediaFolder,
  moveMediaFolder,
  moveMedia,
  MEDIA_FILE_SUCCESS,
} from '../actions/media';
import { CONTENT_SUCCESS } from '../actions/content';
import { MODULES_SUCCESS } from '../actions/modules';
import { PAGE_PROPS_SUCCESS } from '../actions/pageProperties';
import { WEBSITE_SETTINGS_FETCH_SUCCESS } from '../actions/website';
import { COMPONENTS_ARRAY_SCHEMA } from '../api/schema';
import {
  getNewId,
  getContentById,
  createNewColumn,
  resolveNewModuleComponents,
  getMediaById,
  getSectionForComponentById,
  getComponentById,
} from '../utils/entities';

const entities = (state = {
  content: [],
  components: {},
  modules: {},
  pageOrder: [],
  pages: {},
  pageTypes: {
    0: {
      icon: 'page',
      title: 'Basispagina',
    },
  },
  media: {},
  mediaFolder: {},
  links: {},
  languages: [],
}, action) => {
  switch (action.type) {
    case WEBSITE_SETTINGS_FETCH_SUCCESS: {
      const raw = get(action, 'response.enabledComponents', []);
      const entries = normalize(raw, COMPONENTS_ARRAY_SCHEMA);
      const components = get(entries, 'entities.components', {});

      return {
        ...state,
        components,
      };
    }
    case CONTENT_SUCCESS: {
      const { content } = action.response.entities;

      return {
        ...state,
        content,
      };
    }

    case MODULES_SUCCESS: {
      const { modules } = action.response.entities;

      return {
        ...state,
        modules,
      };
    }

    case MEDIA_FILE_SUCCESS:
    case MEDIA_SUCCESS: {
      const { media = {} } = action.response.entities;

      return {
        ...state,
        media: {
          ...state.media,
          ...media,
        },
      };
    }

    case PAGES_SUCCESS: {
      const { pages, pageOrder } = action.response.entities;

      return {
        ...state,
        pages,
        pageOrder,
      };
    }

    case PAGE_PROPS_SUCCESS: {
      if (action.response && action.response.entities) {
        const { pageProps = {} } = action.response.entities;

        return {
          ...state,
          pageProps,
        };
      }

      return state;
    }

    case LANGUAGES_FETCH_SUCCESS: {
      const languages = action.response || [];

      return {
        ...state,
        languages,
      };
    }

    case ADD_CONTENT: {
      const moduleDef = state.modules[action.value.type];
      if (!moduleDef || !moduleDef.columns) {
        return state;
      }
      const addModule = {
        // extra properties required by the sections api endpoint
        deletable: true,
        locked: false,
        editable: true,
        dynamic: false,
        full_width: false,
        // editor properties
        classes: moduleDef.classes,
        columns: cloneDeep(moduleDef.columns),
        options: { ...moduleDef.options },
        ...action.value,
        dndSource: DND_CONTENT_MODULE,
      };
      const moduleColumns = addModule.columns || [{}];
      addModule.columns = moduleColumns.map(column => (
        { ...column, id: getNewId(), components: resolveNewModuleComponents(addModule, column) }
      ));
      const content = state.content.map(c => ({ ...c }));
      content.splice(addModule.index, 0, addModule);
      return {
        ...state,
        content,
      };
    }

    case MOVE_CONTENT: {
      const {
        originalIndex: fromIndex,
        index: toIndex,
        id,
      } = action.value;
      const content = state.content.map(c => ({ ...c }));
      const originalContent = content.filter(c => c.id === id).shift();
      content.splice(fromIndex, 1);
      content.splice(toIndex, 0, originalContent);
      return {
        ...state,
        content,
      };
    }

    case DELETE_CONTENT: {
      const {
        id,
      } = action.value;
      const content = state.content.map(c => ({ ...c }));
      const originalContent = content.filter(c => c.id === id).shift();
      const contentIndex = content.indexOf(originalContent);
      if (contentIndex === -1) {
        return state;
      }
      content.splice(contentIndex, 1);
      return {
        ...state,
        content,
      };
    }

    case SHOW_CONTENT_COMPONENT_BY_TYPE:
    case HIDE_CONTENT_COMPONENT_BY_TYPE: {
      const {
        contentId,
        componentType,
      } = action.value;

      const content = state.content.map(c => ({ ...c }));
      const originalContent = content.filter(c => c.id === contentId).shift();
      const contentIndex = content.indexOf(originalContent);
      if (contentIndex === -1) {
        return state;
      }

      const setEnabled = (component) => {
        if (component.toggelable === false) {
          return component.enabled;
        }
        if (component.type === componentType) {
          if (action.type === SHOW_CONTENT_COMPONENT_BY_TYPE) {
            return true;
          }
          return false;
        }
        return component.enabled;
      };

      const newContent = { ...originalContent };
      const newContentColumns = newContent.columns.map((component) => {
        const newColumn = { ...component, enabled: setEnabled(component) };
        if (component.columns) {
          // eslint-disable-next-line no-param-reassign
          component.columns = component.columns.map(child => ({ ...child, enabled: setEnabled(child) }));
        }
        return newColumn;
      });
      newContent.columns = newContentColumns;
      content.splice(contentIndex, 1);
      content.splice(contentIndex, 0, newContent);
      return {
        ...state,
        content,
      };
    }

    case MERGE_CONTENT_OPTION:
    case SET_CONTENT_OPTION: {
      const {
        option,
        value,
        contentId,
        isRootOption, // option is outside of content.options object
      } = action.value;
      const {
        content,
        originalContent,
        newContent,
        contentIndex,
      } = getContentById(state, contentId);

      if (contentIndex === -1) {
        return state;
      }
      newContent.options = merge({}, originalContent.options);
      if (isRootOption === true) {
        newContent[option] = value;
      } else {
        newContent.options[option] = value;
      }
      content.splice(contentIndex, 1);
      content.splice(contentIndex, 0, newContent);
      return {
        ...state,
        content,
      };
    }

    case CLEAR_CONTENT_OPTION: {
      const {
        option,
        contentId,
      } = action.value;
      const {
        content,
        originalContent,
        newContent,
        contentIndex,
      } = getContentById(state, contentId);
      if (contentIndex === -1) {
        return state;
      }
      newContent.options = merge({}, originalContent.options);
      delete newContent.options[option];
      content.splice(contentIndex, 1);
      content.splice(contentIndex, 0, newContent);
      return {
        ...state,
        content,
      };
    }

    case SET_COMPONENT_OPTION: {
      const {
        option,
        value,
        contentId,
      } = action.value;
      const { content } = state;
      const component = getComponentById(content, contentId);
      const section = getSectionForComponentById(content, contentId);

      if (!component || !section) {
        return state;
      }

      const {
        newContent,
        contentIndex,
      } = getContentById(state, section.id);

      if (contentIndex === -1) {
        return state;
      }

      newContent.updatedAt = new Date();
      const newComponent = getComponentById([newContent], contentId);
      newComponent[option] = value;

      content.splice(contentIndex, 1);
      content.splice(contentIndex, 0, newContent);
      return {
        ...state,
        content,
      };
    }

    case CLEAR_COMPONENT_OPTION: {
      const {
        option,
        contentId,
      } = action.value;
      const { content } = state;
      const component = getComponentById(content, contentId);
      const section = getSectionForComponentById(content, contentId);

      if (!component || !section) {
        return state;
      }

      const {
        newContent,
        contentIndex,
      } = getContentById(state, section.id);

      if (contentIndex === -1) {
        return state;
      }

      const newComponent = getComponentById([newContent], contentId);
      delete newComponent[option];

      content.splice(contentIndex, 1);
      content.splice(contentIndex, 0, newContent);
      return {
        ...state,
        content,
      };
    }

    case SET_CONTENT_COLUMN_COUNT: {
      const {
        value: newColumnCount,
        contentId,
        contentType,
      } = action.value;
      const {
        content,
        newContent,
        contentIndex,
      } = getContentById(state, contentId);
      if (contentIndex === -1) {
        return state;
      }
      const moduleDef = state.modules[contentType];
      if (!moduleDef || !moduleDef.columns) {
        return state;
      }
      const currentColumnCount = newContent.columns.filter(c => c.visible !== false).length;
      // need at least one column
      if (newColumnCount < 1) {
        return state;
      // no change in number of columns
      } if (newColumnCount === currentColumnCount) {
        return state;
      // increase number of columns
      } if (newColumnCount > currentColumnCount) {
        const column = cloneDeep(moduleDef.columns[0]);
        for (let i = currentColumnCount; i < newColumnCount; i += 1) {
          // show hidden column ?
          if (typeof newContent.columns[i] !== 'undefined') {
            newContent.columns[i].visible = true;
          // add new column
          } else {
            newContent.columns.push({
              ...column,
              id: getNewId(),
              components: column.components.map(component => ({ ...component, id: getNewId() })),
            });
          }
        }
        content.splice(contentIndex, 1);
        content.splice(contentIndex, 0, newContent);
        return {
          ...state,
          content,
        };
      // increase number of columns
      } if (newColumnCount < currentColumnCount) {
        newContent.columns = newContent.columns.map((column, idx) => ({ ...column, visible: idx < newColumnCount }));
        content.splice(contentIndex, 1);
        content.splice(contentIndex, 0, newContent);
        return {
          ...state,
          content,
        };
      }

      return state;
    }

    // Copy module (aka blocks) component to existing section.
    // Example: add "image" to gallery or slider.
    // Use action.value.options will extend the new component properties
    // Example: url on new image
    case ADD_COMPONENT: {
      const {
        contentId,
        contentType,
        options,
      } = action.value;
      // Get block definition
      const moduleDef = state.modules[contentType];
      if (!moduleDef || !moduleDef.columns) {
        return state;
      }
      // New component from block definition
      const components = map(moduleDef.columns, 'components').pop();
      if (components.length === 0) {
        return state;
      }
      const newComponent = { id: getNewId(), ...components[0], ...options };
      const { content, newContent, contentIndex } = getContentById(state, contentId);
      if (contentIndex === -1) {
        return state;
      }

      // Add new component to content
      if (!newContent.columns[0]) {
        newContent.columns = [
          createNewColumn(),
        ];
      }

      newContent.columns[0].components.push(newComponent);

      // Use updated content
      content.splice(contentIndex, 1);
      content.splice(contentIndex, 0, newContent);
      return {
        ...state,
        content,
      };
    }

    case ADD_COMPONENT_TO_COLUMN: {
      const {
        contentId,
        columnId,
        type,
      } = action.value;
      const { content, newContent, contentIndex } = getContentById(state, contentId);
      const column = newContent.columns.find(item => item.id === columnId);
      const component = state.components[type];

      if (component) {
        column.components.push({
          ...component,
          id: getNewId(),
        });
      }

      content.splice(contentIndex, 1);
      content.splice(contentIndex, 0, newContent);

      return {
        ...state,
        content,
      };
    }

    case CLONE_CONTENT: {
      const { id } = action.value;
      const { newContent, content, contentIndex } = getContentById(state, id);

      const clonedContent = {
        ...newContent,
        id: getNewId(),
        columns: newContent.columns.map(column => ({
          ...column,
          id: getNewId(),
          components: column.components.map(component => ({
            ...component,
            id: getNewId(),
          })),
        })),
      };

      content.splice(contentIndex + 1, 0, clonedContent);

      return {
        ...state,
        content,
      };
    }

    // Delete Component from Content (aka section)
    // Example: delete "image" to gallery or slider.
    case DELETE_COMPONENT: {
      const {
        id: componentId,
        columnId = null,
      } = action.value;
      // Find current Component
      const section = getSectionForComponentById(state.content, componentId);
      const component = getComponentById(state.content, componentId);
      if (!component || !section) {
        return state;
      }
      // Find current Content (aka section)
      const { id: contentId } = section;
      const { content, newContent, contentIndex } = getContentById(state, contentId);
      if (contentIndex === -1) {
        return state;
      }
      // Remove component from content ( aka section )
      const column = columnId ? newContent.columns.find(c => c.id === columnId) : newContent.columns[0];
      column.components = column.components.filter(c => c.id !== componentId);

      // Use updated content
      content.splice(contentIndex, 1);
      content.splice(contentIndex, 0, newContent);
      // Update state
      return {
        ...state,
        content,
      };
    }

    case MOVE_COMPONENT: {
      const {
        originalIndex: fromIndex,
        index: toIndex,
        id: componentId,
      } = action.value;
      // Find current Component
      const section = getSectionForComponentById(state.content, componentId);
      const component = getComponentById(state.content, componentId);
      if (!component || !section) {
        return state;
      }
      // Find current Content (aka section)
      const { id: contentId } = section;
      const { content, newContent, contentIndex } = getContentById(state, contentId);
      if (contentIndex === -1) {
        return state;
      }
      // Move component to the new position within the array of components
      const newComponents = newContent.columns[0].components;
      // splice will return the an array of the deleted elements, pop get the component
      const originalComponent = newComponents.splice(fromIndex, 1).pop();
      newComponents.splice(toIndex, 0, originalComponent);
      // Update components in content (aka sections)
      newContent.columns[0].components = newComponents;
      // Use updated content
      content.splice(contentIndex, 1);
      content.splice(contentIndex, 0, newContent);
      // Update state
      return {
        ...state,
        content,
      };
    }

    case moveMedia.SUCCESS: {
      const { id } = action.meta;
      const nextState = {
        ...state,
        media: {
          ...state.media,
        },
      };
      delete nextState.media[id];

      return nextState;
    }
    case DELETE_MEDIA: {
      const {
        id: mediaId,
      } = action.value;
      const {
        media,
      } = getMediaById(state, mediaId);

      if (!media) {
        return state;
      }

      delete media[mediaId];

      return {
        ...state,
        media,
      };
    }

    case SET_MEDIA_OPTION: {
      const {
        id: mediaId,
        option,
        value,
      } = action.value;

      const {
        media,
        newMedia,
      } = getMediaById(state, mediaId);

      if (!media) {
        return state;
      }

      newMedia[option] = value;
      media[mediaId] = newMedia;

      return {
        ...state,
        media,
      };
    }

    case PAGE_REORDER: {
      const { pageOrder, pages } = action.value;
      if (!pages || !pageOrder) {
        return state;
      }
      return {
        ...state,
        pageOrder,
        pages,
      };
    }

    case APPEND_COLUMN_COMPONENTS: {
      return {
        ...state,
        content: state.content.map(section => ({
          ...section,
          columns: section.columns.map((column) => {
            if (column.id !== action.value.column.id) {
              return column;
            }

            return {
              ...column,
              components: [
                ...column.components,
                ...action.value.newComponents.map(component => ({
                  ...component,
                  id: getNewId(),
                })),
              ],
            };
          }),
        })),
      };
    }

    case MEDIA_UPLOAD_SUCCESS: {
      const mediaItem = {
        ...action.response,
        wasRecentlyCreated: true,
      };
      const mediaItems = { ...state.media };
      mediaItems[mediaItem.id] = mediaItem;

      return {
        ...state,
        media: mediaItems,
      };
    }
    case MEDIA_FOLDERS_REQUEST: {
      return {
        ...state,
        mediaFolder: {},
      };
    }
    case MEDIA_FOLDERS_SUCCESS: {
      if (action.response && action.response.entities) {
        const { mediaFolder = {} } = action.response.entities;

        return {
          ...state,
          mediaFolder,
        };
      }

      return state;
    }
    case createMediaFolder.SUCCESS:
    case updateMediaFolder.SUCCESS: {
      const { id } = action.response;

      return {
        ...state,
        mediaFolder: {
          ...state.mediaFolder,
          [id]: action.response,
        },
      };
    }
    case moveMediaFolder.SUCCESS:
    case deleteMediaFolder.SUCCESS: {
      const { id } = action.meta;
      const nextState = {
        ...state,
        mediaFolder: {
          ...state.mediaFolder,
        },
      };
      delete nextState.mediaFolder[id];

      return nextState;
    }
    default:
      return state;
  }
};

export default entities;
